export default {
    lang: {
        name: 'Hours played'
    }
}